const func = $target => {
	var $window = $(window),
		$body = $('body'),
		$header = $('header'),
		$submenu = $header.find('#submenu'),
		$navDevice = $('#navDevice'),
		$deviceHeader = $navDevice.find('.device-header');
	//$style = $('<style type="text/css"></style>').appendTo($body);

	var getHeaderHeight = function() {
		return $header.outerHeight() - $submenu.outerHeight();
	};

	$window
		.on('resize', function(e) {
			$target.trigger('mouseleave');
			//$style.html('@media (max-width: ' + window.xsBreakpoint + 'px) { section { min-height:calc(100vh - ' + (getHeaderHeight() + 50) + 'px) !important; }}</style>');
			$deviceHeader.height(getHeaderHeight());
			$body.css('padding-top', getHeaderHeight());
		})
		.trigger('resize');

	window.loader.key('swiper', function() {
		var kdNavCards,
			$steps = $navDevice.find('.steps-clip'),
			$deviceModalShow = $target.find('.btn-device'),
			$deviceModalHide = $navDevice.find('.btn-device'),
			$navDesktop = $('.desktop-primary'),
			$megaMenu = $('.mega-container');

		$deviceModalShow.on('click', function(e) {
			$navDevice.modal({
				keyboard: false
			});
		});

		$deviceModalHide.on('click', function(e) {
			$navDevice.modal('hide');
		});

		$navDevice
			.on('show.bs.modal', function(e) {
				$body.addClass('modal-backdrop-nav');
				$(this).attr('aria-expanded', 'true');
				$deviceModalHide.attr('aria-expanded', 'true');
			})
			.on('shown.bs.modal', function(e) {
				kdNavCards = new Swiper('.kd-nav-cards', {
					slidesPerView: 1.35,
					spaceBetween: 0,
					centeredSlides: false
				});
			})
			.on('hidden.bs.modal', function(e) {
				$deviceModalShow.attr('aria-expanded', 'false');
				$deviceModalHide.attr('aria-expanded', 'false');
			})
			.on('hidden.bs.modal', function(e) {
				$body.removeClass('modal-backdrop-nav');
				$steps.removeClass('next');
				kdNavCards.destroy();
			});

		$steps.find('.device-primary a[data-layout]').on('click', function(e) {
			e.preventDefault();
			var $this = $(this);
			$steps.find('a.prev').text($this.text());
			$steps.find('.step-body [id*="001-"]').removeClass('display');
			$steps.find('#' + $this.attr('data-layout')).addClass('display');
			$steps.find($this.attr('aria-expanded', 'true'));
			$steps.addClass('next');
			kdNavCards.slideTo(0, 0, false);
			kdNavCards.update();
		});
		$steps.find('a.prev').on('click', function(e) {
			e.preventDefault();
			$steps.removeClass('next');
			$steps.find('.device-primary a[data-layout]').attr('aria-expanded', 'false');
		});

		//kill modal for higher breakpoints for better peformance
		$window.on('resize', function(e) {
			if ($window.width() >= window.xsBreakpoint) {
				//kill modal
				if ($navDevice.hasClass('show')) {
					$navDevice.modal('hide');
				}
			}
		});

		var clearLayouts = function() {
			$megaMenu.find('[id^="001-"]').removeClass('show');
			$navDesktop
				.find('a[data-layout]')
				.removeClass('mega-active')
				.attr('aria-expanded', 'false');
			//$window.trigger('resize');
		};

		$navDesktop
			.find('a[data-layout]')
			.on('mouseover', function(e) {
				e.preventDefault();
				clearLayouts();
				var $this = $(this);
				$this.addClass('mega-active').attr('aria-expanded', 'true');
				$megaMenu.find('#' + $this.attr('data-layout')).addClass('show');
				$megaMenu.addClass('show');
			})
			.on('click', function(e) {
				e.preventDefault();
			});

		$target.on('mouseleave', function(e) {
			e.preventDefault();
			$megaMenu.removeClass('show');
			clearLayouts();
		});
	});
};

export default func;
